import { useMemo } from 'react';
import { useBackfillStatus } from './use-backfill-status';

export interface UseBackfillInProgressProps {
  locationIds?: string[];
}

export const useBackfillInProgress = ({ locationIds }: UseBackfillInProgressProps = {}) => {
  const { relevantLocationStatuses, isLoading } = useBackfillStatus(locationIds);

  const backfillInProgressCount = useMemo(() => {
    return relevantLocationStatuses.filter((loc) => loc.isBackfillIncomplete).length;
  }, [relevantLocationStatuses]);

  const pendingBatch1LocationIds = useMemo(() => {
    return relevantLocationStatuses.filter((loc) => !loc.isBatch1Ready).map((loc) => loc.locationId);
  }, [relevantLocationStatuses]);

  return {
    backfillInProgressCount,
    pendingBatch1LocationIds,
    isLoading,
  };
};
